export const CONSTANT = {
  LOCAL_STORAGE_LANG_KEY: 'RC_LANG_KEY',
  LANGUAGES: [
    { key: 'en', name: 'english' },
    { key: 'zh', name: 'chinese' },
    { key: 'es', name: 'spanish' },
    { key: 'idn', name: 'indonesia' },
    { key: 'ja', name: 'japanese' },
    { key: 'ru', name: 'russian' },
    { key: 'th', name: 'thai' },
    { key: 'fr', name: 'french' },
  ],
   SUUPORTED_LANGUAGES: ['en', 'zh', 'es','th','idn','ja','ru', 'fr'],
};
export const DEBUG = true;
